import { io } from "socket.io-client";

export const urlPort = '__RUNTIME_API_URL__' //server url
// export const urlPort = '__RUNTIME_API_URL__' //server url
// export const urlPort = 'http://192.168.46.111:3001' //server url
// export const urlPort = 'http://localhost:3001' //server url
// export const urlPort = 'http://192.168.1.36:3001' //server url

export const socket = io(urlPort);